import { render, staticRenderFns } from "./bonus-table.vue?vue&type=template&id=3d499a47&scoped=true&"
import script from "./bonus-table.vue?vue&type=script&lang=js&"
export * from "./bonus-table.vue?vue&type=script&lang=js&"
import style0 from "./bonus-table.vue?vue&type=style&index=0&id=3d499a47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d499a47",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
